import React from 'react';
import { QRCode } from 'react-qrcode-logo';
import { useNavigate } from 'react-router-dom';

// Material UI
import {
  Grid,
  Typography,
  Card,
  CardContent,
  CardMedia,
  Container,
  Icon,
  List,
  ListItem,
  ListItemIcon,
} from '@mui/material';

// Componentes
import AdminLayout from '@components/MainPage/AdminLayout';

// Utils, Servicios y Middleware
import { getVars } from '@utils/global';
import Logo from '@assets/img/SIAN.png';

const Welcome = () => {
  const navigate = useNavigate();
  const { user } = getVars('Token');

  const username = `${user.Nombre} ${user.Paterno} ${user.Materno}`.split(' ');
  let delayNumber = 0;

  const cardStyles = {
    mb: '0 !important',
    minHeight: 300,
    height: '100%',
    borderRadius: 10,
    transition: 'box-shadow 0.3s ease, transform 0.3s ease, background-color 0.3s ease',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    '&:hover': {
      transform: 'scale(1.05)',
      boxShadow: '0px 8px 16px rgba(0, 0, 0, 0.3)',
      backgroundColor: '#FCE4EC',
      cursor: 'pointer',
    },
  };

  return (
    <AdminLayout>
      <style>{` @keyframes bounce {
                0%,100%{ transform:translate(0); }
                25%{ transform:rotateX(20deg) translateY(2px) rotate(-3deg); }
                50%{ transform:translateY(-10px) rotate(3deg) scale(1.05);  }
              }`}</style>
      <Container
        component="main"
        sx={{ '&:hover .span-word': { animation: 'bounce .6s' } }} /* maxWidth="lg" */
      >
        <Grid container xs={12} spacing={3}>
          <Grid item xs={12}>
            <Typography variant="h5" fontWeight={700}>
              {['¡HOLA!'].concat(username).map((item, index) => (
                <span key={index} style={{ display: 'inline-block', marginRight: 8 }}>
                  {item.split('').map((word, i) => (
                    <span
                      className="span-word"
                      key={i}
                      style={{ display: 'inline-block', animationDelay: `${delayNumber++ * 0.05}s` }}
                    >
                      {word}
                    </span>
                  ))}
                </span>
              ))}
            </Typography>
          </Grid>

          <Grid item xs={12} md={6} lg={6}>
            <Card className="card-primary" onClick={() => navigate('/mi-perfil')} sx={cardStyles}>
              <CardContent>
                <CardMedia sx={{ overflow: 'auto' }}>
                  <QRCode value={user.UUID} logoImage={Logo} size={200} ecLevelc="L" fgColor="#01579b" />
                </CardMedia>
              </CardContent>
            </Card>
          </Grid>

          <Grid item xs={12} md={6} lg={6}>
            <Card className="card-primary" onClick={() => navigate('/mi-perfil')} sx={cardStyles}>
              <CardContent>
                <Grid container spacing={0}>
                  <Grid item xs={12}>
                    <ListItem>
                      <ListItemIcon sx={{ minWidth: 36 }}>
                        <Icon sx={{ color: 'darkblue' }}>manage_accounts</Icon>
                      </ListItemIcon>
                      <Typography fontSize={20} fontWeight={500} color="darkblue">
                        Mi Perfil
                      </Typography>
                    </ListItem>
                  </Grid>
                  <Grid item xs={12}>
                    <List dense>
                      <ListItem>
                        <ListItemIcon sx={{ minWidth: 36 }}>
                          <Icon>qr_code_scanner</Icon>
                        </ListItemIcon>
                        <Typography variant="overline">MI QR identificador</Typography>
                      </ListItem>
                      <ListItem>
                        <ListItemIcon sx={{ minWidth: 36 }}>
                          <Icon>phonelink_off</Icon>
                        </ListItemIcon>
                        <Typography variant="overline">Desvinculación</Typography>
                      </ListItem>
                      <ListItem>
                        <ListItemIcon sx={{ minWidth: 36 }}>
                          <Icon>password</Icon>
                        </ListItemIcon>
                        <Typography variant="overline">Cambio Contraseña</Typography>
                      </ListItem>
                      <ListItem>
                        <ListItemIcon sx={{ minWidth: 36 }}>
                          <Icon>dialpad</Icon>
                        </ListItemIcon>
                        <Typography variant="overline">Cambio PIN</Typography>
                      </ListItem>
                      <ListItem>
                        <ListItemIcon sx={{ minWidth: 36 }}>
                          <Icon>photo_camera</Icon>
                        </ListItemIcon>
                        <Typography variant="overline">Asistencia de eventos</Typography>
                      </ListItem>
                    </List>
                  </Grid>
                </Grid>
              </CardContent>
            </Card>
          </Grid>
        </Grid>
      </Container>
    </AdminLayout>
  );
};

export default React.memo(Welcome);
